import Api from '@/api/checkout-api'
import store from '@/store'
const setUserData = async (context, payload) => {
  let data = await Api.updateUserData(payload)
  if (data) {
    context.commit('USER_DATA_UPDATED', data)
  }
}

const useDelegatedUserData = async (context, payload) => {
  if (payload) {
    context.commit('USER_DATA_UPDATED', payload)
  }
}

const setPaymentMethodWireTransfer = async () => {
  let data = await Api.setWireTransfer()
  if (data) {
    store.dispatch('updatePayment', data)
  }
}

const completePayPal = async (context, payload) => {
  let res = await Api.completePayPalTransaction(payload.orderId)
  context.commit('ORDER_CLOSED', res)
}

const closeOrder = async ({commit, state}) => {
  if (state.acceptedPhoneOptin || state.acceptedPhoneOptin) {
    await Api.setOptinOptions(
      state.acceptedPhoneOptin,
      state.acceptedPhoneOptin,
    )
  }
  if (state.paymentSession != null) {
    if (state.paymentSession.provider == 'amazon') {
      let data = await Api.createAmazonPayRedirect(state.paymentSession.session)
      if (data.valid) {
        window.location.replace(data.redirectUrl)
      }
      return null
    }
  } else {
    let data = await Api.closeOrder()
    if (data) {
      commit('ORDER_CLOSED', data)
    }
  }
}
const updateOptinOptions = async ({state}) => {
  if (state.acceptedPhoneOptin || state.acceptedPhoneOptin) {
    await Api.setOptinOptions(
      state.acceptedPhoneOptin,
      state.acceptedPhoneOptin,
    )
  }
}

const setOptinOptions = (context, payload) => {
  context.commit('OPTIN_UPDATED', payload)
}

const checkOrderNotifications = async context => {
  let data = await Api.getOrderNotifications()
  context.commit('NOTIFICATIONS_UPDATED', data)
}

const createAmazonCheckoutSession = async () => {
  let data = await Api.createAmazonCheckoutSession()
  return data
}

const authorizeAmazonCheckoutSession = async (context, payload) => {
  let data = await Api.authorizeAmazonCheckoutSession(payload.session)
  context.dispatch('updateCart', data, {root: true})
  context.commit('USER_DATA_UPDATED', data.customer)
  store.dispatch('updatePayment', data.paymentType)
  return true
}

const completeAmazonPay = async (context, payload) => {
  let res = await Api.completeAmazonPayPayment(payload.session)
  if (res.paid) {
    context.commit('ORDER_CLOSED', res.order)
  }
  return res
}

const paymentSessionReceived = async (context, payload) => {
  context.dispatch('lockSite', null, {root: true})
  try {
    if (payload.provider == 'amazon') {
      context.dispatch('authorizeAmazonCheckoutSession', payload)
    }
    context.commit('PAYMENT_SESSION_UPDATED', payload)

    context.dispatch('unlockSite', null, {root: true})
    return true
  } catch (e) {
    context.commit('PAYMENT_SESSION_UPDATED', null)
  }
  context.dispatch('unlockSite', null, {root: true})
  return false
}

const clearPaymentSession = context => {
  context.commit('PAYMENT_SESSION_UPDATED', null)
}



export default {
  setUserData,
  setPaymentMethodWireTransfer,
  completePayPal,
  useDelegatedUserData,
  closeOrder,
  setOptinOptions,
  updateOptinOptions,
  checkOrderNotifications,
  createAmazonCheckoutSession,
  paymentSessionReceived,
  authorizeAmazonCheckoutSession,
  completeAmazonPay,
  clearPaymentSession
}
